module.exports = __webpack_public_path__ + "img/71.ca27f9f5.jpg";